import AbstractRequestTask from '../../requests/tasks/AbstractRequestTask';
import { assign } from 'lodash';

class G3Terms extends AbstractRequestTask {
  constructor(url) {
    super();
    this.url = url;
  }

  getUrl() {
    return this.url;
  }

  getParams() {
    const params = super.getParams(this.config);
    this.params = assign(params);
    return params;
  }

  success(data) {
    const { status, errors } = data;
    if (Number(status) > 0 && errors.code !== 'already_accepted') {
      return this.reject(new Error(JSON.stringify(errors)));
    }
    return this.resolve(data);
  }
}

export default G3Terms;
